import { render, staticRenderFns } from "./Grand_24h.vue?vue&type=template&id=3120df3f&scoped=true&"
import script from "./Grand_24h.vue?vue&type=script&lang=js&"
export * from "./Grand_24h.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120df3f",
  null
  
)

export default component.exports